<div
  class="avatar"
  [ngClass]="[size || '', state || '', additionalClass || '']"
  >
  @if (!showInitials) {
    @if (src) {
      <img
        [src]="src"
        [alt]="alt || 'Avatar'"
        (error)="onImageError()"
        class="avatar-image"
        />
    }
  } @else {
    <span class="avatar-initials">
      {{ initials ? initials.slice(0, 2).toUpperCase() : 'NA' }}
    </span>
  }
</div>
